import React from 'react'
import clsx from 'clsx'

type ProgressColor = 'primary' | 'success' | 'warning' | 'error' | 'info'

interface ProgressBarProps {
  value: number
  max?: number
  label?: string
  color?: ProgressColor
  showPercentage?: boolean
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const colorStyles: Record<ProgressColor, string> = {
  primary: 'bg-primary',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
  info: 'bg-info',
}

const sizeStyles: Record<string, string> = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
}

export default function ProgressBar({
  value,
  max = 100,
  label,
  color = 'primary',
  showPercentage = false,
  size = 'md',
  className,
}: ProgressBarProps) {
  const percentage = Math.min(Math.max(Math.round((value / max) * 100), 0), 100)

  return (
    <div className={clsx('w-full', className)}>
      {(label || showPercentage) && (
        <div className="flex justify-between items-center mb-1">
          {label && <span className="text-xs font-medium text-text-secondary">{label}</span>}
          {showPercentage && (
            <span className="text-xs font-semibold text-text-primary">{percentage}%</span>
          )}
        </div>
      )}
      <div className={clsx('w-full bg-gray-200 rounded-full overflow-hidden', sizeStyles[size])}>
        <div
          className={clsx('h-full rounded-full transition-all duration-500', colorStyles[color])}
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  )
}
